/** 主人公の姿。図鑑・撃破状況に関係なく、初回から全種類を選べる（premium の10種は月パスの期間中だけ） */
export const PLAYER_AVATARS = [
  { id: 'player-oni', name: '片角', file: '01-oni.webp' },
  { id: 'player-kurooni', name: '双角', file: '02-kurooni.webp' },
  { id: 'player-karasu', name: '烏天狗', file: '03-karasu.webp' },
  { id: 'player-kitsune', name: '白狐', file: '04-kitsune.webp' },
  { id: 'player-tanuki', name: '化け狸', file: '05-tanuki.webp' },
  { id: 'player-nekomata', name: '猫又', file: '06-nekomata.webp' },
  { id: 'player-ryu', name: '青龍', file: '07-ryu.webp' },
  { id: 'player-yuki', name: '雪男', file: '08-yuki.webp' },
  { id: 'player-kappa', name: '河童', file: '09-kappa.webp' },
  { id: 'player-okami', name: '山犬', file: '10-okami.webp' },
  { id: 'player-raiju', name: '雷獣', file: '11-raiju.webp', premium: true },
  { id: 'player-suzaku', name: '朱雀', file: '12-suzaku.webp', premium: true },
  { id: 'player-orochi', name: '大蛇', file: '13-orochi.webp', premium: true },
  { id: 'player-gyuki', name: '牛鬼', file: '14-gyuki.webp', premium: true },
  { id: 'player-kyubi', name: '九尾', file: '15-kyubi.webp', premium: true },
  { id: 'player-nue', name: '鵺', file: '16-nue.webp', premium: true },
  { id: 'player-tsukiusagi', name: '月兎', file: '17-tsukiusagi.webp', premium: true },
  { id: 'player-onibi', name: '鬼火', file: '18-onibi.webp', premium: true },
  { id: 'player-shishi', name: '獅子', file: '19-shishi.webp', premium: true },
  { id: 'player-kinryu', name: '金龍', file: '20-kinryu.webp', premium: true },
] as const;

export type PlayerAvatarId = typeof PLAYER_AVATARS[number]['id'];
export const DEFAULT_PLAYER_AVATAR: PlayerAvatarId = 'player-oni';
export const isPlayerAvatar = (id: unknown): id is PlayerAvatarId =>
  typeof id === 'string' && PLAYER_AVATARS.some(a => a.id === id);

export const playerAvatar = (id: unknown) => PLAYER_AVATARS.find(a => a.id === id);

/** 月パスの期間中だけ選べる姿 */
export const isPremiumAvatar = (id: unknown) => PLAYER_AVATARS.some(a => a.id === id && 'premium' in a && a.premium);
